import React, {useState} from 'react';
import useWithStore from "@/Hooks/useWithStore";
import {Breadcrumbs} from "@mui/material";
import Link from "@/Layouts/Link";
import BaseLayout from "@/Layouts/BaseLayout";
import Svg from "@/Components/Svg";
import '@/Pages/Split/scss/index.scss';

const Split = (props) => {
    const {mobileApp = false} = props;

    return <BaseLayout {...props}>
        <section className={`section`}>
            {!mobileApp && (
                <div className={`breadcrumbs`}>
                    <div className="container">
                        <Breadcrumbs maxItems={2} itemsAfterCollapse={2}>
                            <Link className={`breadcrumbs__link`} href={`/`}>
                                Главная
                            </Link>
                            <p className={`breadcrumbs__text`}>
                                Покупка в сплит
                            </p>
                        </Breadcrumbs>
                    </div>
                </div>
            )}
            <div className={`container`}>
                <div className={`pageSplit`}>
                    <div className={`mainImage`}>
                        <picture>
                            <source type={`image/webp`}
                                    srcSet={`/storage/img/split/mainImage.webp`}
                            />
                            <img className={``}
                                 src={`/storage/img/split/mainImage.jpg`}
                                 alt={`Яндекс Сплит. Покупай сейчас — плати потом!`}
                                 title={`Яндекс Сплит. Покупай сейчас — плати потом`}
                                 loading={`lazy`}
                            />
                        </picture>
                    </div>
                    <div className={`typesPayments`}>
                        <p className={`typesPayments__title`}>Плати частями или сразу с кешбэком</p>
                        <div className={`typesPayments__body`}>
                            <div className={`typesPayments__item`}>
                                <div className={`typesPayments__icon`}>
                                    <Svg id={`iconPayPage`} className={`svg__iconPayPage`} />
                                </div>
                                <div className={`typesPayments__text`}>
                                    <p className={`typesPayments__subTitle`}>
                                        Выберите Яндекс Пэй
                                    </p>
                                    <p className={`typesPayments__description`}>
                                        Оплачивайте покупку любой картой российских банков и получайте
                                        кешбэк&nbsp;до&nbsp;10%
                                    </p>
                                </div>
                            </div>
                            <div className={`typesPayments__item`}>
                                <div className={`typesPayments__icon`}>
                                    <Svg id={`iconSplitPage`} className={`svg__iconSplitPage`} />
                                </div>
                                <div className={`typesPayments__text`}>
                                    <p className={`typesPayments__subTitle`}>
                                        Оплатите в сплит или сразу с кешбэком баллами Плюса
                                    </p>
                                    <p className={`typesPayments__description`}>
                                        Сплит на 2 месяца будет бесплатным, а сплиты на срок до 2 лет — с небольшой
                                        доплатой
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`howItWorks`}>
                        <p className={`howItWorks__title`}>Как работает оплата Сплит в PLATINA</p>
                        <div className={`howItWorks__body`}>
                            <div className={`howItWorks__item`}>
                                <div className={`howItWorks__line`}></div>
                                <div className={`howItWorks__circle`}>1</div>
                                <p className={`howItWorks__text`}>
                                    Соберите корзину
                                </p>
                            </div>
                            <div className={`howItWorks__item`}>
                                <div className={`howItWorks__line`}></div>
                                <div className={`howItWorks__circle`}>2</div>
                                <p className={`howItWorks__text`}>
                                    Выберите форму оплаты Сплит
                                </p>
                            </div>
                            <div className={`howItWorks__item`}>
                                <div className={`howItWorks__line`}></div>
                                <div className={`howItWorks__circle`}>3</div>
                                <p className={`howItWorks__text`}>
                                    Выберите количество сплитов
                                </p>
                            </div>
                            <div className={`howItWorks__item`}>
                                <div className={`howItWorks__circle`}>4</div>
                                <p className={`howItWorks__text`}>
                                    Получите Ваш товар. Оставшийся платеж спишется по графику
                                </p>
                            </div>
                        </div>
                    </div>
                    <FaqComponent {...props} />
                </div>
            </div>
        </section>
    </BaseLayout>
}

const FaqComponent = (props) => {
    const {faqList = []} = props;

    const [faqState, setFaqState] = useState(() => {
        const state = {};
        faqList.forEach(el => {
            state[`faq_${el.id}`] = false;
        });
        return state;
    });

    const toggleFaq = (id) => {
        setFaqState(state => ({...state, [`faq_${id}`]: !state[`faq_${id}`]}));
    }

    const element = faqList.map((el) => {
        const {id, question = '', answer = ''} = el;
        return <div key={id} className={`faq__item`}>
            <div className={`faq__questionContainer`} onClick={() => toggleFaq(id)}>
                <p className={`faq__question`}>{question}</p>
                <Svg id={`keyboardArrowDownOutlinedIcon`}
                     className={`svg__splitFaqArrow${faqState[`faq_${id}`] ? ' svg__splitFaqArrow_up' : ''}`} />
            </div>
            <div className={`faq__answerContainer${faqState[`faq_${id}`] ? ' visible' : ''}`}>
                <div className={`faq__answer`}>
                    <p>{answer}</p>
                </div>
            </div>
        </div>
    });

    if (faqList.length === 0) return null;

    return <div className={`faq`}>
        <p className={`faq__title`}>Часто задаваемые вопросы</p>
        <div className={`faq__body`}>
            {element}
        </div>
        <div className={`faq__linkContainer`}>
            <a href={`https://bank.yandex.ru/pay`} target={`_blank`} className={`faq__link`}>
                Подробнее на яндекс пэй
            </a>
        </div>
    </div>
}

export default useWithStore(Split);
